import moment from "moment";
import Filters from "../common/filter.jsx";
import Legends from "./legends.jsx";
import AppConfig from "../../../config/config.js";
import BaseComponent from "../../baseComponent.js";
import CssHelper from "../../../core/utils/cssHelper.js";
import DatasetService from "../../../core/services/datasetService.js";
import InternalEvent from "../../../core/constants/internalEvent.js";


export default class SubscriptionActivityTrend extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      activityType: 0,
      periodType: "daily",
      fromDate: moment().add(-7, "days").startOf("day"),
      toDate: moment(),
      datasets: []
    }
  }

  componentDidMount() {
    this.updateChart(this.state.fromDate, this.state.toDate);
  }

  handlePeriodTypeChange(periodType) {
    this.setState({
      periodType: periodType
    });

    if (this.state.toDate > moment()) {
      this.state.toDate = moment();
      this.setState({
        toDate: moment()
      });
    }

    // TODO: temporary filter for yearly based range
    if (periodType === "yearly") {
      var start = moment().startOf("year"),
        end = moment("2017-01-01").endOf("year");
      this.setState({
        fromDate: start,
        toDate: end
      });
      this.updateChart(start, end);
      return;
    }

    this.updateChart(this.state.fromDate, this.state.toDate);
  }

  handleDateFilterChange(type, date) {

    if (type === "fromDate") {
      this.setState({
        fromDate: date.startOf("day")
      });
      this.updateChart(date, this.state.toDate);
    } else {
      this.setState({
        toDate: date.endOf("day")
      });
      this.updateChart(this.state.fromDate, date);
    }
  }

  updateChart(fromDate, toDate) {
    var _this = this;
    var startTime = fromDate.toISOString().slice(0, -1);
    var endTime = toDate.toISOString().slice(0, -1);
    this.publish(InternalEvent.App.SHOW_PRELOADER);

    if (this.state.periodType === "daily") {
      DatasetService.getAccessAuditInDays(startTime, endTime, update);
    } else {
      DatasetService.getAccessAuditInMonths(startTime, endTime, update);
    }

    function update(response) {
      var preparedData = _this.prepareData(response.data, fromDate, toDate);
      _this.setState({
        datasets: preparedData.datasets
      });

      if (_this.chart) {
        _this.chart.option({
          domain: preparedData.domain,
          tickFormats: {
            bottom: (value) => {
              return preparedData.bottomTicks[value];
            }
          },
          ticks: {
            bottom: preparedData.bottomTicks.length > 35 ? 35 : preparedData.bottomTicks.length
          }
        });
        _this.chart.update(preparedData.data);
      } else {
        var $chart = $(_this.refs.chart);
        _this.chart = $chart.epoch({
          type: 'line',
          data: preparedData.data,
          domain: preparedData.domain,
          ticks: {
            bottom: preparedData.bottomTicks.length > 35 ? 35 : preparedData.bottomTicks.length
          },
          margins: {
            right: 30
          },
          tickFormats: {
            bottom: (value) => {
              return preparedData.bottomTicks[value];
            }
          }
        });
      }

      $(_this.refs.chart).find('svg').width($(_this.refs.chart).width());
      $(_this.refs.chart).find('svg').height($(_this.refs.chart).height());
      _this.publish(InternalEvent.App.HIDE_PRELOADER);
    }
  }

  prepareData(data, fromDate, toDate) {
    var datasetIndexMap = {};
    var datasets = [];
    var type = this.state.periodType;

    for (var i = 0; i < data.length; i++) {
      if (!datasetIndexMap.hasOwnProperty(data[i].dataset)) {
        var propCount = Object.keys(datasetIndexMap).length;
        datasetIndexMap[data[i].dataset] = propCount;
        datasets.push(data[i]);
      }
    }

    return prepareDailyData();

    function prepareDailyData() {
      var layeredData = [];
      var bottomTicks = [];
      var diffType = "days";
      var format = "M/D";

      if (type === "monthly") {
        diffType = "months";
        format = "MMM YYYY";
      } else if (type === "yearly") {
        diffType = "years";
        format = "YYYY";
      }

      var numberOfDays = toDate.diff(fromDate, diffType) + 1;

      for (var i = 0; i < Object.keys(datasetIndexMap).length; i++) {
        layeredData[i] = {
          label: "DataSeries " + i,
          values: []
        };
        for (var j = 0; j < numberOfDays; j++) {
          layeredData[i].values.push({
            x: j,
            y: 0
          })
        }
      }

      var date = moment(fromDate);
      for (var i = 0; i < numberOfDays; i++) {
        bottomTicks.push(date.format(format));
        date.add(1, diffType);
      }

      for (var i = 0; i < data.length; i++) {
        var localDate = new Date(data[i].time);
        var dataTime = moment(localDate).endOf("day");
        var dayIndex = Math.abs(fromDate.diff(dataTime, diffType));
        var datasetIndex = datasetIndexMap[data[i].dataset];
        layeredData[datasetIndex].values[dayIndex].y = data[i].accessCount;
      }

      return {
        data: layeredData,
        domain: [0, numberOfDays - 1],
        bottomTicks: bottomTicks,
        datasets: datasets
      };
    }

  }

  handleToggleLegend(index) {
    this.chart.toggleLayer("DataSeries " + index);
  }

  handleFocusLegend(index) {
    this.chart.focusSingleLayer(index);
  }

  componentWillUnmount() {
  }

  render() {
    return (
      <div className="profile-sata">
        <Filters activityType={this.state.activityType}
                 periodType={this.state.periodType}
                 fromDate={this.state.fromDate}
                 toDate={this.state.toDate}
                 onPeriodTypeChange={this.handlePeriodTypeChange}
                 onDateFilterChange={this.handleDateFilterChange}/>
        <div id="sata-chart" className="profile-sata__chart epoch category10" ref="chart"></div>
        <Legends datasets={this.state.datasets}
                 onLegendHover={this.handleFocusLegend}
                 onToggleLegend={this.handleToggleLegend}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/analysis/subscriptionActivityTrend.jsx